import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IDelivery, IQueryResult, IDeliveriesQueryParams } from 'gen/ApiClient';

export const DeliveriesQueryContext = React.createContext<IQueryContext<IQueryResult<IDelivery>, IDeliveriesQueryParams>>(undefined as any);
